import { useSearchParams } from "react-router-dom";
import { useTranslation } from "../../../../../hooks/useTranslation";
import { FolderSelect } from "../FolderSelect/FolderSelect";
import { classNames } from "../../../../../utils/helpers/classNames";
import { Actions } from "./components/Actions/Actions";

import { ProxyType } from "./components/ProxyType/ProxyType";

export const Top = ({ renewalProxyCount, selectedTableType, setSelectedTableType, folderSelectRef, openFolderSelect, closeFolderSelect, controller, folders, setFolders }) => {
  const { cabinet: { orders, orders: { all, renewal } } } = useTranslation();

  const types = [
    { value: "all", label: all },
    // { value: "replaced", label: "Replaced" }
    { value: "renewal", label: `${renewalProxyCount ? `${renewal} (${renewalProxyCount})` : `${renewal}`}` }
  ];

  const [searchParams, setSearchParams] = useSearchParams();

  const changeTableType = (type) => {
    searchParams.delete("runningOuts");
    setSearchParams(searchParams);
    setSelectedTableType(type);
    // resetFilterSearchParams(searchParams, setSearchParams);
    // setTimeout(() => setSelectedTableType(type), 100);
  };

  return (
    <>
      <div className="orders__top">
        <div className="orders__top__box-title">
          <div className="orders__title-container">
            <div className="orders__title">{orders?.title}</div>
            <div className="orders__types">
              {types.map(({ value, label }) => (
                <div
                  key={value}
                  onClick={() => changeTableType(value)}
                  className={classNames(
                    "orders__type",
                    { "orders__type--active": value === selectedTableType }
                  )}
                >
                  {label}
                </div>
              ))}
            </div>
          </div>
          {selectedTableType === "all" && (
            <div className="orders__folder-select">
              <FolderSelect
                folders={folders}
                setFolders={setFolders}
                controller={controller}
                folderSelectRef={folderSelectRef}
                openFolderSelect={openFolderSelect}
                closeFolderSelect={closeFolderSelect}
              />
            </div>
          )}
        </div>
        <div className="orders__top__box-actions">
          <ProxyType/>
          <Actions/>
        </div>
      </div>
    </>
  );
};
